import { Link } from 'react-router-dom';

interface ArticleItem {
  title: string;
  excerpt: string;
  imageUrl: string;
  link: string;
  internal: boolean;
}

const articles: ArticleItem[] = [
  {
    title: 'What Is Hipobuy Spreadsheet? Complete Beginner Guide',
    excerpt: 'Learn everything about Hipobuy Spreadsheet — how it works, why thousands of shoppers rely on it, and how to get started in minutes.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20digital%20workspace%20featuring%20tablet%20device%20displaying%20colorful%20organized%20spreadsheet%20dashboard%20on%20clean%20white%20oak%20desk%20surface%2C%20small%20succulent%20plant%20beside%20it%2C%20soft%20morning%20light%20from%20window%2C%20warm%20and%20bright%20atmosphere%2C%20productive%20tech%20lifestyle%20photography%2C%20minimal%20and%20professional%20aesthetic%2C%20no%20text%20visible%2C%20clean%20modern%20composition&width=800&height=500&seq=articles-v2-guide-main&orientation=landscape',
    link: '/what-is-hipobuy-sheet',
    internal: true,
  },
  {
    title: 'Kakobuy Spreadsheet Guide 2026 — Resources & Comparison',
    excerpt: 'Explore how Kakobuy Spreadsheet organizes products and how it compares to Hipobuy. Detailed feature breakdown and practical recommendations.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Clean%20bright%20desk%20scene%20with%20laptop%20showing%20organized%20comparison%20charts%20on%20screen%20beside%20handwritten%20notes%20and%20colorful%20markers%2C%20warm%20clay%20colored%20ceramic%20mug%2C%20diffused%20natural%20daylight%2C%20creative%20research%20workspace%20aesthetic%2C%20earthy%20neutral%20tones%20with%20sage%20green%20accents%2C%20editorial%20photography%2C%20focused%20productive%20mood%2C%20no%20text%20visible&width=800&height=500&seq=articles-v2-kakobuy&orientation=landscape',
    link: '/kakobuy-spreadsheet',
    internal: true,
  },
  {
    title: 'CSSBuy Spreadsheet Guide — Complete Resource & Review',
    excerpt: 'Deep dive into CSSBuy Spreadsheet features, community-driven curation model, and how it fits into your shopping stack alongside Hipobuy.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Organized%20creative%20workspace%20with%20open%20notebook%20showing%20structured%20data%20pages%20alongside%20tablet%20device%20on%20light%20stone%20desk%2C%20small%20glass%20vase%20with%20single%20stem%20dried%20flower%2C%20soft%20afternoon%20light%20creating%20gentle%20shadows%2C%20warm%20camel%20and%20ivory%20palette%2C%20calm%20research%20atmosphere%2C%20modern%20minimalist%20studio%2C%20no%20text%20visible%2C%20editorial%20lifestyle%20photography&width=800&height=500&seq=articles-v2-cssbuy&orientation=landscape',
    link: '/cssbuy-spreadsheet',
    internal: true,
  },
  {
    title: 'Superbuy Spreadsheet Review — Features & Honest Comparison',
    excerpt: 'Everything about Superbuy Spreadsheet: speed-optimized interface, comparison engine, and how it stacks up against Hipobuy for power users.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Minimal%20workspace%20featuring%20dual%20monitor%20setup%20displaying%20data%20dashboards%20on%20warm%20walnut%20desk%20surface%2C%20small%20espresso%20cup%20and%20mechanical%20keyboard%2C%20soft%20ambient%20lighting%20from%20desk%20lamp%2C%20modern%20productive%20atmosphere%2C%20rich%20dark%20wood%20and%20warm%20cream%20tones%2C%20tech%20professional%20aesthetic%2C%20no%20text%20visible%2C%20contemporary%20office%20photography&width=800&height=500&seq=articles-v2-superbuy&orientation=landscape',
    link: '/superbuy-spreadsheet',
    internal: true,
  },
  {
    title: 'Oopbuy Spreadsheet Guide — Honest Review & Platform Analysis',
    excerpt: 'A thorough look at Oopbuy Spreadsheet adaptive categorization system, strengths, weaknesses, and how it complements Hipobuy Spreadsheet.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Thoughtfully%20styled%20desk%20arrangement%20with%20open%20notebook%20and%20tablet%20showing%20organized%20data%20on%20light%20ash%20wood%20surface%2C%20steaming%20herbal%20tea%20in%20handmade%20ceramic%20cup%2C%20small%20trailing%20ivy%20plant%2C%20soft%20golden%20hour%20light%2C%20warm%20earthy%20tones%20with%20blush%20accents%2C%20contemplative%20creative%20workspace%2C%20no%20text%20visible%2C%20editorial%20lifestyle%20composition&width=800&height=500&seq=articles-v2-oopbuy&orientation=landscape',
    link: '/oopbuy-spreadsheet',
    internal: true,
  },
];

const ArticlesSection = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100" id="articles">
      <div className="px-6 md:px-10 lg:px-20 max-w-[1400px] mx-auto">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/60 text-accent-800 text-sm font-medium mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            Spreadsheet Authority
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 mb-4">
            Latest Spreadsheet Guides
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            Expert-written comparison guides covering Hipobuy, Kakobuy, CSSBuy, Superbuy, and Oopbuy spreadsheets. Updated regularly with fresh insights and honest platform analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.slice(0, 3).map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:bg-accent-50/30 transition-colors"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{article.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-primary-600 text-sm font-semibold">
                  Read Article <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {articles.slice(3, 5).map((article) => (
            <Link
              key={article.title}
              to={article.link}
              className="group bg-background-50 rounded-xl overflow-hidden cursor-pointer hover:bg-accent-50/30 transition-colors flex flex-col sm:flex-row"
            >
              <div className="sm:w-2/5 h-48 sm:h-auto overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 sm:w-3/5 flex flex-col justify-center">
                <h3 className="font-heading text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">{article.excerpt}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-primary-600 text-sm font-semibold">
                  Read Article <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticlesSection;